module.exports = "dbd1f66b1f2614085b4e6c3b4961946a.wav";


//////////////////
// WEBPACK FOOTER
// ./assets/sfx/collect_star.wav
// module id = 82
// module chunks = 0